import { Flex, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import {
  AUTOMATIC_PAYMENT_REMINDERS_MAX_DAYS,
  AUTOMATIC_PAYMENT_REMINDERS_MIN_DAYS,
  AutomaticPaymentRemindersDaysSelect,
} from '@features/invoicingSettings/modules/paymentsAndReminders'

import { AutomaticPaymentRemindersEmailFields } from '../AutomaticPaymentRemindersEmailFields'

export const AutomaticPaymentRemindersBeforeDueDate = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column">
      <Text weight="bold">
        {t('settings.organization.external_invoice.automatic_payment_reminders.modal.description')}
      </Text>
      <Space size="s8" />
      <Flex alignItems="center" gap={Spacing.S8}>
        <AutomaticPaymentRemindersDaysSelect />
        <Text variant="bodySM" colorVariant="label">
          {t(
            'settings.organization.external_invoice.automatic_payment_reminders.modal.form.before_due_date.description',
            {
              max: AUTOMATIC_PAYMENT_REMINDERS_MAX_DAYS,
              min: AUTOMATIC_PAYMENT_REMINDERS_MIN_DAYS,
            },
          )}
        </Text>
      </Flex>
      <Space size="s16" />
      <AutomaticPaymentRemindersEmailFields />
    </Flex>
  )
}
